import { createFileRoute } from '@tanstack/react-router';

import { requirePermission } from '@/app/guards';
import { MyChatProfilePage } from '@/features/chat-settings';

/** The signed-in member's chat name and avatar per store; reading it needs conversations.read. */
export const Route = createFileRoute('/_authed/_active/account/chat-profile')({
  staticData: { crumb: 'chatSettings:profile.crumb' },
  beforeLoad: ({ context }) => {
    requirePermission(context.me, 'conversations.read');
  },
  component: MyChatProfilePage,
});
